const initState = {
  validateIdentity: {
    success: null,
    error: null,
    code: null,
    message: null,
    errorDetail: null,
  },
};

export default initState;
